import { Route } from 'vue-router/types/router';

export default (route: Route): string => {
  if (!route.params.channelSlug1) {
    return route.params.channelSlug0;
  }
  return route.params.channelSlug0 + '@' + route.params.channelSlug1;
};
